<template>
  <div class="spinner-container bg-white">
    <loader/>
  </div>
</template>

<script setup lang="ts">
import ThirdParty from "supertokens-web-js/recipe/thirdparty";
import {AdminRouteNames, AuthRouteNames} from "@app/router/route-names";
import {useRouter} from "vue-router";
import {useAuthError} from "@app/composables/auth-error";

const router = useRouter();
const {setAuthError} = useAuthError();

const load = async () => {
  try {
    const response = await ThirdParty.signInAndUp({});
    // Email already registered with email+password — the backend rejects the Google sign-up
    // with a GENERAL_ERROR (not in the SDK's narrowed return type, but present at runtime).
    // Set the shared error BEFORE navigating; the global AuthErrorDialog shows it on the login page.
    if ((response as { status: string; message?: string }).status === "GENERAL_ERROR") {
      setAuthError((response as { message?: string }).message || 'לא הצלחנו לחבר אותך. אנא נסו שוב');
      return router.push({name: AuthRouteNames.AdminLogin});
    }
    if (response.status !== "OK") {
      return router.push({name: AuthRouteNames.AdminLogin, params: {error: 'signin'}});
    }
    await router.push({name: AdminRouteNames.Home});
  } catch (err: any) {
    // supertokens-web-js THROWS a GENERAL_ERROR (STGeneralError) — e.g. the Google email
    // already has an email+password account. Surface its message via the global dialog.
    if (err?.isSuperTokensGeneralError === true) {
      setAuthError(err.message || 'לא הצלחנו לחבר אותך. אנא נסו שוב');
      return router.push({name: AuthRouteNames.AdminLogin});
    }
    return router.push({name: AuthRouteNames.AdminLogin, params: {error: 'signin'}});
  }
};

load();
</script>
